import type { GroupMemberRoles } from '@group/domain/GroupEntity/GroupMemberRoles';
import type { GroupLicense } from '@group/domain';

type Props = {
  license: GroupLicense;
  memberRoles: GroupMemberRoles;
};

export const GroupLicenseUsage: React.FC<Props> = ({ license, memberRoles }: Props) => {
  return (
    <div className="ml-4 border-2 border-slate-300 bg-gray-100 p-2">
      <div className="flex">
        <div className="min-w-40">ライセンス数：</div>
        <div className="min-w-20 text-right">
          {memberRoles.regularUserIds().length} / {license.count}
        </div>
      </div>
      <div className="flex">
        <div className="min-w-40">ゲストライセンス数：</div>
        <div className="min-w-20 text-right">
          {memberRoles.guestUserIds().length} / {license.count}
        </div>
      </div>
    </div>
  );
};
